const getInitials = ({ firstName, lastName } = {}) => {
  if (!firstName && !lastName) return '';
  return `${firstName ? firstName.charAt(0) : ''}${lastName ? lastName.charAt(0) : ''}`.toUpperCase();
};

export default getInitials;
